import { useApolloClient } from '@apollo/client/react';

import type { ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { useReportContext } from '@modules/_shared/components/report-editor/ReportEditorContext';
import type { ListingBrochureType } from '@modules/reports/brochure-report/BrochureReportEditor/BrochureReportEditor';
import { GET_BROCHURE_REPORT } from '@modules/reports/brochure-report/brochureReportsQueries';
import StepPointsOfInterest from '@modules/reports/shared/StepPointsOfInterest/StepPointsOfInterest';
import { useUpdateListingBrochure } from '@modules/reports/shared/utils';

const StepPOIBrochure = (props: ReportComponentProps) => {
  const client = useApolloClient();
  const [updateListingBrochure] = useUpdateListingBrochure(
    props.reportId,
    'page-point-of-interest',
  );
  const { data } = useReportContext();
  const brochureReport = data as ListingBrochureType;

  const includePoiMap = brochureReport?.brochure_include_poi_map ?? true;
  const poiMapZoomLevel = brochureReport?.brochure_poi_map_zoom_level ?? null;

  return (
    <StepPointsOfInterest
      {...props}
      reportType="brochure"
      updateReport={() =>
        updateListingBrochure({
          // We can't pass an empty object like in the CMA report
          // because we have a trigger on the lots table
          updated_at: new Date().toISOString(),
        })
      }
      refetchQuery={GET_BROCHURE_REPORT}
      pageId="page-point-of-interest"
      includePoiMap={includePoiMap}
      poiMapZoomLevel={poiMapZoomLevel}
      onIncludePoiMapChange={value => {
        client.cache.modify({
          id: client.cache.identify({ __typename: 'lots', id: props.reportId }),
          fields: {
            brochure_include_poi_map: () => value,
          },
        });
        return updateListingBrochure({ brochure_include_poi_map: value });
      }}
      onPoiMapZoomLevelChange={value => {
        client.cache.modify({
          id: client.cache.identify({ __typename: 'lots', id: props.reportId }),
          fields: {
            brochure_poi_map_zoom_level: () => value,
          },
        });
        return updateListingBrochure({ brochure_poi_map_zoom_level: value });
      }}
    />
  );
};

export default StepPOIBrochure;
